<template>
  <div class="manage-skill-modal modal" role="alert">
    <div class="manage-skill-modal__wrapper">
      <button
        class="manage-skill-modal__close"
        @click="$emit('close-manage-skill-dive-modal')"
      >
        <XIcon class="manage-skill-modal__close--icon" />
      </button>
      <template>
        <div
          :class="[
            'manage-skill-modal__title-wrapper',
            isLoading && 'manage-skill-modal__loading',
          ]"
        >
          <h5 class="manage-skill-modal__title">
            Manage Skill Dive
          </h5>
        </div>
        <div :class="[isLoading && 'manage-skill-modal__loading']">
          <div class="manage-skill-modal__subtitle">Add a learning area</div>
          <div class="manage-skill-modal__description">
            <span>You have the Cyber Security learning area.</span> Explore
            other learning areas for just $99 each!
          </div>
          <div class="manage-skill-modal__addons-wrapper">
            <div
              v-for="addon in validAddons"
              :key="addon.item_code"
              class="manage-skill-modal__addon"
              @click="handleAddonSelected(addon.item_code)"
            >
              <div class="manage-skill-modal__addons-content">
                <Passes
                  :passName="getLearningAreaName(addon.item_code)"
                  :size="34"
                  :laNoBorders="true"
                  class="learning-area__title--icon"
                />
                <span>{{ getLearningAreaName(addon.item_code) }}</span>
              </div>
              <div class="manage-skill-modal__addons-content">
                <span
                  class="manage-skill-modal__addons-content manage-skill-modal__bolded"
                  >{{ addon.due_today.total }}</span
                >
                <input
                  class="manage-skill-modal__checkbox"
                  type="checkbox"
                  :checked="
                    addonsSelected.find(
                      selected => selected.code === addon.item_code
                    )
                  "
                />
              </div>
            </div>
          </div>
        </div>
        <div class="manage-skill-modal__actions">
          <button
            id="save-changes"
            class="btn btn--primary"
            :disabled="addonsSelected.length === 0 || isLoading"
            @click="handleSaveChanges()"
          >
            Save changes
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import CONSTANTS from '@/constants'
import Passes from '@/components/properties/Passes.vue'
import { XIcon } from 'vue-feather-icons'
export default {
  name: 'ManageSkillDiveModal',
  components: {
    Passes,
    XIcon,
  },
  props: {
    validAddons: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data: () => {
    return {
      addonsSelected: [],
    }
  },
  methods: {
    getLearningAreaName(item_code) {
      return CONSTANTS.SKILL_DIVE.ITEM_CODES[item_code]
    },
    handleAddonSelected(item_code) {
      if (this.isLoading) return
      if (this.addonsSelected.find(addon => addon.code === item_code)) {
        this.addonsSelected = this.addonsSelected.filter(
          addon => addon.code !== item_code
        )
      } else {
        this.addonsSelected.push({ code: item_code })
      }
    },
    handleSaveChanges() {
      this.$emit('save-skill-modal-changes', this.addonsSelected)
    },
  },
}
</script>

<style lang="scss" scoped>
.manage-skill-modal {
  $this: &;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 402;
  background: rgba(113, 113, 113, 0.8);
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  &__wrapper {
    display: flex;
    gap: 25px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
    margin: auto;
    background: var(--glass-mid-gray);
    color: var(--black);
    width: 35%;
    height: auto;
    border-radius: 24px;
    padding: 30px;
    overflow-y: auto;
    &:before {
      position: absolute;
      content: '';
      width: 100%;
      height: 100%;
      border-radius: 24px;
      background: var(--black);
      z-index: -1;
      top: 0;
      left: 0;
    }
  }
  &__close {
    width: 24px;
    height: 24px;
    position: absolute;
    right: 30px;
    top: 30px;
    background: none;
    border: none;
    cursor: pointer;
    color: var(--white);
    padding: 0;
    &:hover {
      .upgrade__close--icon {
        fill: var(--orange);
      }
    }
    &--icon {
      fill: var(--white);
    }
  }
  &__title-wrapper {
    text-align: center;
    margin: 20px 0;
  }
  &__title {
    margin: 0;
    color: var(--white);
    font-size: 40px;
    line-height: 52px;
    font-family: var(--font-bold);
  }
  &__subtitle {
    color: var(--white);
    font-size: 20px;
    font-family: var(--font-bold);
  }
  &__description {
    color: var(--light-blue-gray);
    font-size: 16px;
    line-height: 24px;
    margin: 5px 0px 20px 0px;
    span {
      color: var(--white);
      font-family: var(--font-bold);
    }
  }
  &__addons {
    &-wrapper {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    &-content {
      display: flex;
      gap: 10px;
      align-items: center;
      span {
        font-weight: 500;
        font-size: 18px;
        line-height: 24px;
      }
    }
  }
  &__addon {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
    align-items: center;
    gap: 12px;
    align-self: stretch;
    border: 1px solid var(--white);
    color: var(--white);
    background: var(
      #37373e,
      linear-gradient(
        105deg,
        rgba(62, 63, 73, 0.7) -13.91%,
        rgba(62, 63, 73, 0) 100.48%
      )
    );
    border-radius: 12px;
    backdrop-filter: blur(6.452303886413574px);
  }
  &__checkbox {
    border: 1px solid var(--mid-gray-dark);
    border-radius: 8px;
    margin: 0 5px;
    appearance: none;
    background: none;
    color: var(--white);
    padding: 11px;
    width: 30px;
    height: 30px;
    &:hover:not([disabled]) {
      border: 1px solid var(--white);
      cursor: pointer;
    }
    &:checked {
      border: 1px solid var(--white);
      background: var(--mid-gray-dark-25);
      color: var(--white);
      position: relative;
      display: inline-block;
      &::before {
        transform: rotate(40deg);
        content: '';
        position: absolute;
        width: 1px;
        height: 9px;
        background-color: var(--white);
        left: 15px;
        top: 10px;
      }
      &::after {
        transform: rotate(-45deg);
        content: '';
        position: absolute;
        width: 1px;
        height: 4px;
        background-color: var(--white);
        left: 11px;
        top: 14px;
      }
    }
  }
  &__actions {
    width: 100%;
    padding-top: 10px;
    button {
      width: 100%;
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    @include mobile {
      display: flex;
      flex-direction: row-reverse;
      button {
        width: fit-content;
        margin-bottom: 0;
        margin-left: 20px;
        &:last-child {
          margin-bottom: 0;
          margin-left: 0;
        }
      }
    }
  }
  &__loading {
    opacity: 0.4;
  }
  &__bolded {
    font-weight: 700 !important;
  }
}
</style>
